<template>
  <div>
    <div class="query_wapper">
      <div class="query_item" style="margin-right:10px">
        <el-select
            :popper-append-to-body="false"
            placeholder="年份查询"
            style="width:200px"
            clearable
            v-model="query.year"
        >
          <el-option
              v-for="(item,index) in yearLists"
              :value="item.value"
              :label="item.label"
              :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          :popper-append-to-body="false"
          placeholder="性别"
          style="width:200px"
          clearable
          v-model="query.gender"
        >
          <el-option label="全部" value="all"></el-option>
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          :popper-append-to-body="false"
          placeholder="按类别"
          style="width:200px"
          clearable
          v-model="query.type"
          @change="selectType"
        >
          <el-option label="全部" value="all"></el-option>
          <el-option label="阳光体育" :value="1"></el-option>
          <el-option label="竞技项目" :value="2"></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          :popper-append-to-body="false"
          placeholder="按项目查询"
          style="width:200px"
          clearable
          v-model="query.project"
        >
          <el-option
            v-for="item in projectList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          :popper-append-to-body="false"
          placeholder="入学时间查询"
          style="width:200px"
          clearable
          v-model="query.startYear"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          :popper-append-to-body="false"
          placeholder="入学性质查询"
          style="width:200px"
          clearable
          v-model="query.sportsLevel"
        >
          <el-option label="普通生" :value="1"></el-option>
          <el-option label="体育生" :value="2"></el-option>
          <el-option label="高水平" :value="3"></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:290px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item" style="margin-right:0">
        <el-button
          style="width:90px;padding:12px 0;text-align:center"
          type="primary"
          @click="exportExcel"
        >导出EXCEL</el-button>
        <el-button style="width:90px" type="warning" @click="print">打印</el-button>
      </div>
    </div>
    <printTable
      :printTitle="schoolName + '年度新增注册运动员汇总表'"
      ref="print_table"
      :printColumns="printColumns"
      :printTableData="printTableData"
    ></printTable>
    <div style="font-size:24px">{{schoolName}}年度新增注册运动员汇总表</div>
    <el-table border style="width:100%;margin-top:40px" :data="tableData">
      <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名" width="120"></el-table-column>
      <el-table-column prop="gender" align="center" label="性别" width="60">
        <template slot-scope="scope">
          <span>{{!scope.row.gender?'女':'男'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nation" align="center" label="民族" width="90"></el-table-column>
      <el-table-column prop="schoolName" align="center" label="学校名称" width="100"></el-table-column>

      <el-table-column prop="phone" align="center" label="手机号码" width="120"></el-table-column>>
      <el-table-column align="center" label="出生年月" width="100">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.birthday,'slash')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="idCard" align="center" label="身份证号码" width="130"></el-table-column>
      <el-table-column align="center" label="入学时间" width="100">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.startSchoolDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="major" align="center" label="就读专业" width="100"></el-table-column>
      <el-table-column align="center" label="学制" width="80">
        <template slot-scope="scope">
          <span>{{schoolSystem(scope.row.schoolSystem)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="studentNumber" align="center" label="学生证号" width="100"></el-table-column>
      <el-table-column prop="sportsLevel" align="center" label="入学性质" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.sportsLevel === 1?'普通生':scope.row.sportsLevel === 2?'体育生':scope.row.sportsLevel === 3?'高水平':''}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="注册类别" width="90">
        <template slot-scope="scope">
          <span>{{scope.row.type === 1?'阳光体育':scope.row.type === 2?'竞技项目':''}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="注册组别" width="100">
        <template slot-scope="scope">
          <span>{{getGroup(scope.row.group)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="注册项目" width="100">
        <template slot-scope="scope">
          <span>{{registProject(scope.row.projectFirst)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="registerNumber" align="center" label="注册号" width="100"></el-table-column>
      <el-table-column align="center" label="有效期" width="100">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.endSchoolDate,'slash')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coachName" align="center" label="教练员" width="100"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import printTable from "@/components/print-table";
import registerData from "@/assets/json/register.json";
import { page, table, message, formatPrintTableData,selectiveYear } from "@/common/js/mixins";
import { getAthleteList } from "@/api/athletes";
import { method } from "@/utils/utils";
import { baseUrl } from "@/utils/config";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page, table, message, formatPrintTableData,selectiveYear],
  components: {
    printTable
  },
  data() {
    return {
      query: {
        gender: "",
        keyword: "",
        type: "",
        project: "",
        startYear: "",
        year: null,
        sportsLevel: "",
        isNew: 1
      },
      printColumns: [
        {
          title: "序号",
          key: "index",
          width: 50
        },
        {
          title: "姓名",
          key: "name",
          width: 80
        },
        {
          title: "性别",
          key: "genderText",
          width: 40
        },
        {
          title: "民族",
          key: "nation"
        },
        {
          title: "学校名称",
          key: "schoolName"
        },
        {
          title: "手机号码",
          key: "phone",
          width: 70
        },
        {
          title: "出生年月",
          key: "birthdayText",
          width: 70
        },
        {
          title: "身份证号码",
          key: "idCard",
          width: 100
        },
        {
          title: "入学时间",
          key: "startSchoolDateText",
          width: 70
        },
        {
          title: "就读专业",
          key: "major"
        },
        {
          title: "学制",
          key: "schoolSystemText",
          width: 60
        },
        {
          title: "学生证号",
          key: "studentNumber",
          width: 70
        },
        {
          title: "入学性质",
          key: "sportsLevelText"
        },
        {
          title: "注册类别",
          key: "typeText"
        },
        {
          title: "注册组别",
          key: "groupText"
        },
        {
          title: "注册项目",
          key: "projectFirst"
        },
        {
          title: "注册号",
          key: "registerNumber",
          width: 100
        },
        {
          title: "有效期",
          key: "endSchoolDateText",
          width: 70
        },
        {
          title: "教练员",
          key: "coachName"
        }
      ],
      schoolName: JSON.parse(getSession("userInfo")).schoolName || "",
      projectList: []
    };
  },
  computed: {
    // 筛选学制
    schoolSystem() {
      return data => {
        let label = "";
        registerData.educationalList.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 筛选组别
    getGroup() {
      return data => {
        let str = "";
        switch (data) {
          case '1': {
            str = "甲组（普通本科）";
            break;
          }
          case '2': {
            str = "乙组（高职高专）";
            break;
          }
          case '3': {
            str = "丁组（高水平）";
            break;
          }
          case '4': {
            str = "丙组（体育院系";
            break;
          }
          default:
            str = "";
            break;
        }
        return str;
      };
    },
    // 格式化时间
    formatTime() {
      return (data, type = null) => {
        return method.timeFormat(data, type);
      };
    },
    // 筛选注册项目
    registProject() {
      return data => {
        let label = "";
        this.projectList.filter(item => {
          if (item.value === data) label = item.label;
        });
        return label;
      };
    }
  },
  methods: {
    // 打印
    async print() {
      let { list } = await getAthleteList({
        ...this.query,
        pageNo: 1,
        pageSize: 9999,
        gender: this.query.gender === "all" ? "" : this.query.gender,
        type: this.query.type === "all" ? "" : this.query.type
      });
      // 调用公共方法打印（方法在mixins.js)
      this.getPrintData(list);
    },
    // 获取项目
    getProjectList(value) {
      if (!value)
        this.projectList = [
          ...registerData.sportsProjectList,
          ...registerData.sunshineProject
        ];
      else {
        this.projectList =
          value === 1
            ? [...registerData.sunshineProject]
            : [...registerData.sportsProjectList];
      }
    },
    // 选择类别后对应项目组也要切换
    selectType(value) {
      this.query.project = "";
      if (value) {
        this.getProjectList(value);
      }
    },
    // 表格导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      params.push("pageNo=" + this.pageNo);
      params.push("pageSize=" + this.pageSize);

      window.location.href =
        baseUrl + "/athlete/downloadAllList?" + params.join("&");
    },
    // 查询
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 列表查询
    getList() {
      getAthleteList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gender: this.query.gender === "all" ? "" : this.query.gender,
        type: this.query.type === "all" ? "" : this.query.type
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getProjectList();
    this.getYearLists(null, this.getList,6);
  }
};
</script>
<style lang="less" scoped>
</style>
